/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Phosphorus View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PhosphorusView';

export const mapStateToPropsPhosphorus = mapStateToProps;
export const mapDispatchToPropsPhosphorus = mapDispatchToProps;

export default connect(
  mapStateToPropsPhosphorus,
  mapDispatchToPropsPhosphorus
)(View);
